import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { Auth0Provider, AuthorizationParams } from '@auth0/auth0-react';
import AuthenticationClientManager from '@dashboard/contexts/AuthenticationClientManager';
import SnackbarManager from '@dashboard/contexts/SnackbarManager';
import ThemeManager from '@dashboard/contexts/ThemeManager';

const AUTH0_DOMAIN = WAYPOINT_CONFIGURATION.auth0.domain;
const AUTH0_CLIENT_ID = WAYPOINT_CONFIGURATION.auth0.clientId;
const AUTH0_AUTHORIZATION_PARAMS: AuthorizationParams = {
  redirect_uri: WAYPOINT_CONFIGURATION.auth0.redirectUri,
  scope: 'openid profile email execute:all',
  audience: 'waypoint-api',
};
const WAYPOINT_API_HOST = WAYPOINT_CONFIGURATION.apiHost;

export default function ApplicationPageLayout() {
  return (
    <>
      <ScrollRestoration />
      <ThemeManager>
        <Auth0Provider
          authorizationParams={AUTH0_AUTHORIZATION_PARAMS}
          domain={AUTH0_DOMAIN}
          clientId={AUTH0_CLIENT_ID}
          cacheLocation="localstorage"
        >
          <AuthenticationClientManager apiHost={WAYPOINT_API_HOST}>
            <SnackbarManager />
            <Outlet />
          </AuthenticationClientManager>
        </Auth0Provider>
      </ThemeManager>
    </>
  );
}
